// extracted by mini-css-extract-plugin
export default {"title":"yBt414m8"};